import { ActivitiesInternalResource as e } from "./resources/ActivitiesInternalResource.js";
import { AgentConfigurationResource as t } from "./resources/agent-configuration/AgentConfigurationResource.js";
import { AgentGatewayConfiguration as n } from "./resources/AgentGatewayConfiguration.js";
import { AnnouncementsResource as r } from "./resources/AnnouncementsResource.js";
import { AnswerResource as i } from "./resources/answer/AnswerResource.js";
import { AutomationFreezesResource as a } from "./resources/AutomationFreezesResource.js";
import { BatchAnswerResource as o } from "./resources/batch-answer/BatchAnswerResource.js";
import { CaseAssistConfigsInternalResource as s } from "./resources/CaseAssistConfigstInternalResource.js";
import { CatalogsInternalResource as c } from "./resources/CatalogsInternalResource.js";
import { ChunkInspectorResource as l } from "./resources/chunk-inspector/ChunkInspectorResource.js";
import { CommerceResource as u } from "./resources/commerce/Commerce.js";
import { ConditionResource as d } from "./resources/ConditionResource.js";
import { ConversationInspectorResource as f } from "./resources/conversation-inspector/ConversationInspectorResource.js";
import { CrawlingModuleInternalResource as p } from "./resources/CrawlingModuleInternalResource.js";
import { CRGADashboardResource as m } from "./resources/crga-dashboard/CRGADashboardResource.js";
import { DataServiceResource as h } from "./resources/DataServiceResource.js";
import { DocumentIdentityResource as g } from "./resources/DocumentIdentityResource.js";
import { ExportServiceResource as _ } from "./resources/ExportServiceResource.js";
import { ExtensionInternalResource as v } from "./resources/ExtensionInternalResource.js";
import { HostedPagesInternalResource as y } from "./resources/HostedPagesInternalResource.js";
import { InAppWidgetResource as b } from "./resources/InAppWidgetResource.js";
import { InsightPanelConfigsInternalResource as x } from "./resources/InsightPanelConfigsInternalResource.js";
import { IPXInterfaceExperimentalResource as S } from "./resources/IPXInterfaceResource.js";
import { LicenseInternalResource as C } from "./resources/LicenseInternalResource.js";
import { LogicalIndexesResource as w } from "./resources/LogicalIndexesResource.js";
import { MCPConfigurationsResource as T } from "./resources/MCPConfigurationsResource.js";
import { MCPPipelinesResource as E } from "./resources/MCPPipelinesResource.js";
import { ModelsInternalResource as D } from "./resources/ModelsInternalResource.js";
import { NextGenSearchPagesInternalResource as O } from "./resources/NextGenSearchPagesInternalResource.js";
import { NotificationEventResource as k } from "./resources/NotificationEventResource.js";
import { OrganizationCustomerKeysResource as A } from "./resources/OrganizationCustomerKeysResource.js";
import { OrganizationDefinitionResource as j } from "./resources/OrganizationDefinitionResource.js";
import { OrganizationHealthMonitoringResource as M } from "./resources/OrganizationHealthMonitoringResource.js";
import { OrganizationInternalResource as N } from "./resources/OrganizationInternalResource.js";
import { OrganizationMonitoringResource as P } from "./resources/OrganizationMonitoringResource.js";
import { OrganizationQuotasResource as F } from "./resources/OrganizationQuotasResource.js";
import { OrganizationSettingsResource as I } from "./resources/OrganizationSettingsResource.js";
import { PipelineInternalResource as L } from "./resources/PipelineInternalResource.js";
import { PipelineSettingsResource as R } from "./resources/PipelineSettingsResource.js";
import { PreviewResource as z } from "./resources/PreviewResource.js";
import { PrivateLicenseResource as B } from "./resources/PrivateLicenseResource.js";
import { PrivilegesResource as V } from "./resources/PrivilegesResource.js";
import { ProjectInternalResource as H } from "./resources/ProjectInternalResource.js";
import { ReportInternalResource as U } from "./resources/ReportInternalResource.js";
import { SalesforceSourceConfigurationInternalResource as W } from "./resources/SalesforceSourceConfigurationInternalResource.js";
import { SchemaServiceTemporaryResource as G } from "./resources/SchemaServiceTemporaryResource.js";
import { SearchDictionaryFieldsResource as K } from "./resources/SearchDictionaryFieldsResource.js";
import { SearchInterfacesInternalResource as q } from "./resources/SearchInterfacesInternalResource.js";
import { SearchPagesInternalResource as J } from "./resources/SearchPagesInternalResource.js";
import { SecurityCacheInternalResource as Y } from "./resources/SecurityCacheInternalResource.js";
import { SourcesInternalResource as X } from "./resources/SourcesInternalResource.js";
import { WebsitesInternalResource as Z } from "./resources/WebsitesInternalResource.js";
import { PlatformClient as Q } from "@coveo/platform-client";
//#region src/PrivatePlatformClient.ts
var $ = [
	{
		key: "activitiesInternal",
		resource: e
	},
	{
		key: "agentConfiguration",
		resource: t
	},
	{
		key: "agentGatewayConfiguration",
		resource: n
	},
	{
		key: "announcements",
		resource: r
	},
	{
		key: "answer",
		resource: i
	},
	{
		key: "automationFreezes",
		resource: a
	},
	{
		key: "batchAnswer",
		resource: o
	},
	{
		key: "catalogsInternal",
		resource: c
	},
	{
		key: "caseAssistConfigsInternal",
		resource: s
	},
	{
		key: "chunkInspector",
		resource: l
	},
	{
		key: "commerce",
		resource: u
	},
	{
		key: "conversationInspector",
		resource: f
	},
	{
		key: "condition",
		resource: d
	},
	{
		key: "crawlingModuleInternal",
		resource: p
	},
	{
		key: "crgaDashboard",
		resource: m
	},
	{
		key: "dataService",
		resource: h
	},
	{
		key: "documentIdentity",
		resource: g
	},
	{
		key: "exportService",
		resource: _
	},
	{
		key: "extensionInternal",
		resource: v
	},
	{
		key: "inAppWidget",
		resource: b
	},
	{
		key: "insightPanelConfigsInternal",
		resource: x
	},
	{
		key: "hostedPagesInternal",
		resource: y
	},
	{
		key: "ipxInterfaceExperimental",
		resource: S
	},
	{
		key: "licenseInternal",
		resource: C
	},
	{
		key: "logicalIndexes",
		resource: w
	},
	{
		key: "mcpConfigurations",
		resource: T
	},
	{
		key: "mcpPipelines",
		resource: E
	},
	{
		key: "modelsInternal",
		resource: D
	},
	{
		key: "nextGenSearchPagesInternal",
		resource: O
	},
	{
		key: "notificationEvent",
		resource: k
	},
	{
		key: "organizationInternal",
		resource: N
	},
	{
		key: "organizationCustomerKeys",
		resource: A
	},
	{
		key: "organizationDefinition",
		resource: j
	},
	{
		key: "organizationQuotas",
		resource: F
	},
	{
		key: "organizationHealthMonitoring",
		resource: M
	},
	{
		key: "organizationMonitoring",
		resource: P
	},
	{
		key: "organizationSettings",
		resource: I
	},
	{
		key: "pipelineInternal",
		resource: L
	},
	{
		key: "pipelineSettings",
		resource: R
	},
	{
		key: "privateLicense",
		resource: B
	},
	{
		key: "preview",
		resource: z
	},
	{
		key: "privileges",
		resource: V
	},
	{
		key: "projectInternal",
		resource: H
	},
	{
		key: "reportInternalResource",
		resource: U
	},
	{
		key: "salesforceSourceConfigurationInternal",
		resource: W
	},
	{
		key: "schemaServiceTemporary",
		resource: G
	},
	{
		key: "searchDictionaryFields",
		resource: K
	},
	{
		key: "searchInterfacesInternal",
		resource: q
	},
	{
		key: "searchPagesInternal",
		resource: J
	},
	{
		key: "sourcesInternal",
		resource: X
	},
	{
		key: "securityCacheInternal",
		resource: Y
	},
	{
		key: "websitesInternal",
		resource: Z
	}
], ee = class extends Q {
	constructor(e) {
		super(e), $.forEach(({ key: e, resource: t }) => {
			this[e] = new t(this.API, this.ServerlessAPI);
		});
	}
};
//#endregion
export { ee as PrivatePlatformClient };

//# sourceMappingURL=PrivatePlatformClient.js.map